// ----------------------------------------------------------------------------
// Template: Blog
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'sections/header/header';
import 'snippets/pagination/pagination';
import 'sections/hero/hero';
import 'sections/main-blog/main-blog';
import 'sections/blog-posts/blog-posts-grid';
import 'sections/footer/footer';